import {useSelector} from "react-redux";
import {useEffect} from "react";

export function useMapVisibility({map, layerId, afterLayerId, compare}) {
    const visibility = useSelector(state => state.changes.visibility)


    useEffect(() => {
        const layer = map.getLayer(layerId)
        layer && map.setPaintProperty(layerId, 'raster-opacity', compare(visibility))
        const layer2 = map.getLayer(afterLayerId)
        layer2 && map.setPaintProperty(afterLayerId, 'raster-opacity', 1 - compare(visibility))
    }, [map, layerId, visibility])
}



// WEBPACK FOOTER //
// ./src/hooks/mapHooks.js